// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import '../../../css/common.css';
import '../../../css/initialConfigStyle.css';
import InitialConfigHeader from '../../../components/InitialConfig/UserInitialConfigHeader';
import StepIntro from '../../../components/InitialConfig/StepIntro'
import WorkflowNavigationButtons from '../../../components/InitialConfig/WorkflowNavigationButtons';
import WorkflowIlustration from "../../../components/InitialConfig/WorkflowIlustration";
import ReactGA from "react-ga4";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const getInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/getInstallationConfiguration"

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js");
var generalCommonJS = require("../../../js/generalCommon.js")

// Initial config - InstallationElements
const InstallationElements = () => {

  useEffect(() => {    

    if(initialConfigCommonJS.antiBackOnboarding() === false){

      if(localStorage.getItem("installationConfigurationMode") === null){
        localStorage.removeItem("currentInstallationConfiguration")
        localStorage.removeItem("configuredApps")
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGISTRO', 'REGISTRO - ELEMENTOS INSTALACIÓN', "", "")
      }
      else{
        document.getElementById("initialConfigBreadcrumb").className = document.getElementById("initialConfigBreadcrumb").className.replaceAll(" hidden", "") + " hidden"
      }

      initialConfigCommonJS.actualizarPasoWorkflowEnBBDD("INSTALLATION_ELEMENTS")
      cargarConfiguracionActualPaso()

      visibilidadOpcionesPorTipoSuscripcion()

      document.title = "HELIAS - Configuración inicial: Elementos de la instalación"
    }
    
  }, []);

  const [illustrationElements, setIllustrationElements] = useState([])

  function visibilidadOpcionesPorTipoSuscripcion(){

    var datosStripe = {}
                      
    if( (localStorage.getItem("stripeData") !== null) && (Object.keys(JSON.parse(localStorage.getItem("stripeData")).length > 0)) ){
      datosStripe = JSON.parse(localStorage.getItem("stripeData"))        
    } 

    if (datosStripe.priceId.includes("PB")){
      document.getElementById("botonPaneles").className = document.getElementById("botonPaneles").className.replaceAll(" hidden", "")
      document.getElementById("botonBaterias").className = document.getElementById("botonBaterias").className.replaceAll(" hidden", "")
      document.getElementById("botonGrupo").className = document.getElementById("botonGrupo").className.replaceAll(" hidden", "")
      document.getElementById("botonCoche").className = document.getElementById("botonCoche").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("botonDispositivos").className = document.getElementById("botonDispositivos").className.replaceAll(" hidden", "") + " hidden"
    }
    else if(datosStripe.priceId.includes("PA")){
      document.getElementById("botonPaneles").className = document.getElementById("botonPaneles").className.replaceAll(" hidden", "")
      document.getElementById("botonBaterias").className = document.getElementById("botonBaterias").className.replaceAll(" hidden", "")
      document.getElementById("botonGrupo").className = document.getElementById("botonGrupo").className.replaceAll(" hidden", "")
      document.getElementById("botonCoche").className = document.getElementById("botonCoche").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("botonDispositivos").className = document.getElementById("botonDispositivos").className.replaceAll(" hidden", "")
    }
    else{ // Es premium
      document.getElementById("botonPaneles").className = document.getElementById("botonPaneles").className.replaceAll(" hidden", "")
      document.getElementById("botonBaterias").className = document.getElementById("botonBaterias").className.replaceAll(" hidden", "")
      document.getElementById("botonGrupo").className = document.getElementById("botonGrupo").className.replaceAll(" hidden", "")
      document.getElementById("botonCoche").className = document.getElementById("botonCoche").className.replaceAll(" hidden", "")
      document.getElementById("botonDispositivos").className = document.getElementById("botonDispositivos").className.replaceAll(" hidden", "")
    }

  }

  function cargarConfiguracionActualPaso(){
  
    var elementosNavegacion = localStorage.getItem("customizedWorkflow")
  
    if(elementosNavegacion !== null){
      elementosNavegacion = localStorage.getItem("customizedWorkflow").split(",")     
      
      for (var i = 0; i < elementosNavegacion.length; i++) {
        if(elementosNavegacion[i] === "FV"){document.getElementById("solar-panels").checked = true}
        else if(elementosNavegacion[i] === "BATTERY"){document.getElementById("batteries").checked = true}
        else if(elementosNavegacion[i] === "GENERATOR"){document.getElementById("generator").checked = true}
        else if(elementosNavegacion[i] === "CARS"){document.getElementById("car").checked = true}
        else if(elementosNavegacion[i] === "DEVICES"){document.getElementById("smart-devices").checked = true}
     }
  
    }

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    
  
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "GeneralInfo": "",
      "Meteo": "",
      "FV": "",
      "Battery": "",
      "Generator": "",
      "Cars": "",
      "Messaging": ""
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          

            setIllustrationElements(initialConfigCommonJS.cargaInicialIlustracion(jsonRespuesta.body))

            console.log("Información cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {  
          initialConfigCommonJS.mostrarMensajeInformativo('Se produjo un error al cargar la configuracion.',"negative")
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);      
    
  }  

  function actualizarImagen(imagen){

    if( imagen === "FV" ){
      if(document.getElementById("solar-panels").checked){ setIllustrationElements(initialConfigCommonJS.modificarIlustracion(illustrationElements, "agregar", "FV")) }
      else{setIllustrationElements(initialConfigCommonJS.modificarIlustracion(illustrationElements, "quitar", "FV"))}
    }
    
    if( imagen === "BATTERY" ){
      if(document.getElementById("batteries").checked){ setIllustrationElements(initialConfigCommonJS.modificarIlustracion(illustrationElements, "agregar", "BATTERY_IN")) }
      else{setIllustrationElements(initialConfigCommonJS.modificarIlustracion(illustrationElements, "quitar", "BATTERY_IN"))}
    }

    if( imagen === "GENERATOR" ){
      if(document.getElementById("generator").checked){ setIllustrationElements(initialConfigCommonJS.modificarIlustracion(illustrationElements, "agregar", "GENERATOR")) }
      else{setIllustrationElements(initialConfigCommonJS.modificarIlustracion(illustrationElements, "quitar", "GENERATOR"))}
    }

    if( imagen === "CARS" ){
      if(document.getElementById("car").checked){ 
        setIllustrationElements(initialConfigCommonJS.modificarIlustracion(illustrationElements, "agregar", "CARS")) 
      }
      else{
        setIllustrationElements(initialConfigCommonJS.modificarIlustracion(illustrationElements, "quitar", "CARS"))        
      }
    }

    if( imagen === "DEVICES" ){
      if(document.getElementById("smart-devices").checked){ setIllustrationElements(initialConfigCommonJS.modificarIlustracion(illustrationElements, "agregar", "DEVICES")) }
      else{setIllustrationElements(initialConfigCommonJS.modificarIlustracion(illustrationElements, "quitar", "DEVICES"))}
    }

  }

  function guardarInformacionPaso(direccion){
  
      var nuevoFlujo = []
  
      nuevoFlujo.push('INSTALLATION_ELEMENTS') //Añado la entrada al flujo
      if(document.getElementById("solar-panels").checked){nuevoFlujo.push('FV')}
      if(document.getElementById("batteries").checked){nuevoFlujo.push('BATTERY')}
      if(document.getElementById("generator").checked){nuevoFlujo.push('GENERATOR')}
      if(document.getElementById("car").checked){nuevoFlujo.push('CARS')}
      if(document.getElementById("smart-devices").checked){nuevoFlujo.push('DEVICES')}
      nuevoFlujo.push('MESSAGING_USER') //Añado la salida del flujo
  
      localStorage.setItem('customizedWorkflow', nuevoFlujo)
  
      initialConfigCommonJS.actualizarPasoWorkflowEnBBDD("INSTALLATION_ELEMENTS")
    
      // Y continuo a la siguiente página    
      if(localStorage.getItem("installationConfigurationMode") === null){
        if(localStorage.getItem("ongoingStepConfiguration") === "INSTALLATION_ELEMENTS" ){          
          initialConfigCommonJS.navegarDinamico(direccion)
        }
        else{
          initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
        }
      }
  }
  
  function navegar(direccion){
    if(initialConfigCommonJS.existeSesion()){
      if(direccion === "continuar"){    
        guardarInformacionPaso(direccion)
      }
      else{
        if(localStorage.getItem("ongoingStepConfiguration") === "INSTALLATION_ELEMENTS"){      
          initialConfigCommonJS.navegarDinamico(direccion)
        }
        else{
          initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
        }
      }
    }
  }

  return (
    <main>
              
        <InitialConfigHeader step={"INSTALLATION_ELEMENTS"}/>

        <section id="welcome-02" className="step wrapper">
            <div className="content-wrapper half">
                
                <StepIntro 
                  Title="Elementos de tu instalación" 
                  Intro={<><p>Dime qué cosas tienes actualmente...</p></>}
                />
                
                <fieldset className="check multiple">

                  <input type="checkbox" id="solar-panels" onClick={() => actualizarImagen("FV")}/>
                  <label id="botonPaneles" className="icon-wrapper" htmlFor="solar-panels">
                    <figure className="avatar size-m"><span className="material-icon">solar_power</span></figure>
                    <span className="label">Paneles solares</span>
                  </label>

                  <input type="checkbox" id="batteries" onClick={() => actualizarImagen("BATTERY")}/>
                  <label id="botonBaterias" className="icon-wrapper" htmlFor="batteries">
                    <figure className="avatar size-m"><span className="material-icon">battery_std</span></figure>
                    <span className="label">Baterías</span>
                  </label>

                  <input type="checkbox" id="generator" onClick={() => actualizarImagen("GENERATOR")}/>
                  <label id="botonGrupo" className="icon-wrapper" htmlFor="generator">
                    <figure className="avatar size-m"><span className="material-icon">dynamic_form</span></figure>
                    <span className="label">Grupo electrógeno</span>
                  </label>

                  <input type="checkbox" id="car" onClick={() => actualizarImagen("CARS")}/>
                  <label id="botonCoche" className="icon-wrapper" htmlFor="car">
                    <figure className="avatar size-m"><span className="material-icon">directions_car</span></figure>
                    <span className="label">Coche eléctrico</span>
                  </label>

                  <input type="checkbox" id="smart-devices" onClick={() => actualizarImagen("DEVICES")}/>
                  <label id="botonDispositivos" className="icon-wrapper" htmlFor="smart-devices">
                    <figure className="avatar size-m"><span className="material-icon">devices_other</span></figure>                    
                    <div className="content">
                      <span className="label">Dispositivos inteligentes</span>
                      <p className="clarification size-s">Ej: Luces, enchufes, etc...</p>
                    </div>
                  </label>

                </fieldset>         

                <WorkflowNavigationButtons step={"INSTALLATION_ELEMENTS"} navegar={navegar}/>

            </div> 

            <WorkflowIlustration illustrationElements={illustrationElements}/>

        </section>
      
    </main>
    
  )
}

export default InstallationElements